<div class="row d-flex justify-content-center">
  <div id="picture-select-card" class="card d-inline-flex mb-0 input-form">
    <div class="card-body d-inline-flex flex-column" id="card-body">
      <div id="close-button-container">
        <button type="button" title="close button" id="close-button" (click)="emitStop()">
          <i title="{{translate('back', {}, 'common')}}" class="feather icon-x  pull-right"></i>
        </button>
      </div>
      <div class="d-flex justify-content-center">
        <h4>{{translate("choose-picture")}}</h4>
      </div>
      <div class="row d-flex picture-grid">
        <div class="col-3" *ngFor="let pic of availablePictures()">
          <div class="picture">
            <button class="btn btn-primary-outline p-0 password-image border-0" (click)="addPictureToSelection(pic.key)"
                    [disabled]="!isPictureSelectionAllowed">
              <img alt="login-picture" [src]="pic.getImageUrl()">
            </button>
          </div>
        </div>
      </div>
      <div class="mb-1">
        <au-notification-bar #notificationBar> </au-notification-bar>
      </div>
      <div id="picture-progress">
        <div *ngFor="let i of [1,2,3]" class="circle-container">
          <span class="progress-circle shrink" [ngClass]="{ 'fill': hasSelectedNeededAmount(i) }">
          </span>
        </div>
        <div class="circle-container">
          <button type="button" title="delete picture" class="btn btn-primary-outline p-0 border-0" id="remove-last-selection"
                  (click)="removePicture()" [disabled]="!hasSelectedPictures">
            <i class="feather icon-arrow-left pointer "> </i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
